<template>
	<div class="app-top-bar">
		<div class="brand">
			<span class="brand-icon">
				<font-awesome-icon icon="chart-line" class="pointer" @click="goRoot" />
			</span>

			<span class="brand-title no-select pointer" @click="goRoot">
				{{ $t('topbar.app_title') }}
			</span>
		</div>

		<div class="section-title" v-show="appBarCollapsed">
			{{ sectionTitle }}
		</div>

		<!-- <breadcrumbs /> -->

		<user-dropdown>
			<user-dropdown-item @click="logout" icon="sign-out-alt">Logout</user-dropdown-item>
			<user-dropdown-item @click="settings" icon="cog">Settings</user-dropdown-item>
		</user-dropdown>

		<!-- <b-dropdown :text="user.name" size="sm" variant="link" toggle-class="user-dropdown-label" class="user-dropdown">
			<b-dropdown-item-button @click="logout">Logout</b-dropdown-item-button>
		</b-dropdown> -->
	</div>
</template>

<script>
import UserDropdown from '../topbar/UserDropdown';
import UserDropdownItem from '../topbar/UserDropdownItem';
// import Breadcrumbs from '../topbar/Breadcrumbs'

export default {
	components: {
		UserDropdown,
		UserDropdownItem
		// Breadcrumbs
	},

	computed: {
		/**
		 * Returns the `appBarCollapsed` property from the store.
		 *
		 * @returns {boolean}
		 */
		appBarCollapsed () {
			return this.$store.getters['ui/appBarCollapsed'];
		},

		/**
		 * Returns the `currentSection` property from the store.
		 *
		 * @returns {string}
		 */
		sectionTitle () {
			return this.$store.getters['ui/currentSection'];
		}
	},

	methods: {
		/**
		 * Dispatches the logout process from the store, then redirects the user
		 * back to login.
		 *
		 * @returns {void}
		 */
		logout () {
			this.$store.dispatch('auth/logout')
				.then(() => {
					this.$store.dispatch('sidebar/storageClear');
					this.$router.replace({ name: 'login' });
				});
		},
		settings () {
			this.$router.push('/account-settings');
		},
		goRoot () {
			this.$router.push('/');
		}
	}
};
</script>

<style lang="scss">
@import '../../_variables';

.no-select {
	user-select: none;
}

.app-top-bar {
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	height: $app-topbar-height;
	background-color: $app-topbar-bg;
	z-index: 1000;

	.brand {
		display: inline-block;
		width: $app-sidebar-width;
		color: $app-topbar-color;
		margin-top: 10px;

		.brand-icon {
			display: inline-block;
			margin-left: 10px;
			margin-right: 10px;
			width: 30px;
			height: 30px;
			font-size: 18px;
			background-color: white;
			color: $orange;
			line-height: 20px;
			padding: 5px;
			border-radius: 15px;
			vertical-align: middle;
		}

		.brand-title {
			font-size: 12px;
			font-weight: bold;
			color: $app-topbar-color;
		}

		&.collapsed {
			width: $app-sidebar-collapsed-width;
		}
	}

	.section-title {
		display: inline-block;
		width: $section-sidebar-width;
		line-height: $app-topbar-height;
		color: $app-topbar-color;
		text-transform: uppercase;
		font-weight: $font-semibold;
		font-size: 12px;
		letter-spacing: 1px;
		text-align: left;
	}
}
</style>
